/*eslint-disable */
export default [
	{
		path: "/",
		component: () => import(/* webpackChunkName: "layout" */ '@/projects/simple/views/layout/PageLayout.vue'),
		children: [
			{
				path: '/',
				name: 'index',
				component: () => import(/* webpackChunkName: "page_index" */ '@/projects/simple/views/common/index.vue'),
				meta: {title: '首页'}
			},
			{
				path: '/detail/:staticUrl',
				name: 'page_detail',
				component: () => import(/* webpackChunkName: "page_detail" */ '@/projects/simple/views/detail/index.vue'),
				meta: {title: '详情'}
			},
			{
				path: '/page/:column',
				name: 'common_page',
				component: () => import(/* webpackChunkName: "page_index" */ '@/projects/simple/views/index/index.vue'),
				props: true,
				meta: {title: '页面'}
			},
		],
	},
	{
		path: '/autoLogin',
		name: 'page_auto_login',
		component: () => import(/* webpackChunkName: "page_auto_login" */ '@/projects/simple/views/AutoLogin/index.vue'),
		meta: {title: '详情'}
	},
];